import { cardListStyles } from "@insite/content-library/Widgets/SavedPayments/SavedPaymentsCardList";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { GridOffset } from "@insite/mobius/GridContainer";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { changeCustomerSelectCustomerContainerStyles as buttonStyle } from "@tKgpco/Overrides/Widgets/ChangeCustomer/ChangeCustomerSelectCustomerContainer";
import { COLORS, TYPOGRAPHY } from "@tKgpco/theme/design";
import { css } from "styled-components";

Object.assign(cardListStyles, {
    titleGridItem: {
        // width: [12, 12, 5, 5, 5],
        width: 12,
    },
    titleText: {
        variant: "h2",
        as: "h2",
        css: css`
            margin-bottom: 0;
        `,
    },
    sortByGridItem: {
        // width: [12, 12, 7, 7, 7],
        width: 12,
    },
    sortBySelect: {
        labelPosition: "left",
        labelProps: {
            css: css`
                width: auto;
            `,
        },
        cssOverrides: {
            formField: css`
                margin-bottom: 1rem;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            justify-content: flex-start;
                        `,
                        css`
                            justify-content: flex-start;
                        `,
                        css`
                            justify-content: flex-start;
                        `,
                        css`
                            justify-content: flex-start;
                        `,
                        css`
                            justify-content: flex-start;
                        `,
                    ])}
            `,
        },
    },
    useAsDefaultButton: buttonStyle.cancelButton,
    cardInfoContainer: {
        gap: 0,
        css: css`
            > ${GridOffset} {
                width: calc(100% + 30px) !important;
            }
        `,
    },
});
